import React, { useEffect, useState } from 'react';
import { Avatar } from '@/components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import cryptoGift from '@/assets/images/crypto-gift.svg';
import {
  AwardsDto,
  CampaignUserDtoRead,
  TaskPublicDto,
  useCampaignControllerVerifyCampaignMutation,
} from '@/store/services/MidleNestApi.service';
import { useProfile, useRemainingTime } from '@/hooks';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

export default function CarouselItem({
  id,
  customer,
  title,
  description,
  image,
  // name = '',
  // profilePicture = '',
  // profileName = '',
  isCampaignCompleted,
  tasks = [],
  awards = [],
  endDate,
  completedTaskIds = [],
}: CampaignUserDtoRead & {
  // picture?: string;
  // profilePicture?: string;
  // profileName?: string;
  // name?: string;

  // TODO: asagidakilerde problem var (2023-08-22 merge)
  tasks: TaskPublicDto[];
  // title: { en: '' };
  // description: { en: '' };
  // customerId: '';
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const remainingTime = useRemainingTime(endDate);

  const profile = customer.profile;

  const {
    profile: { id: userId },
  } = useProfile();

  const [_isCampaignCompleted, setIsCampaignCompleted] = useState(isCampaignCompleted);

  // console.log(tasks.length, completedTaskIds.length, _isCampaignCompleted, title);

  const [verifyCampaign] = useCampaignControllerVerifyCampaignMutation();

  const handleComplete = async (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    // TODO handle Error
    await verifyCampaign(id)
      .unwrap()
      .then(() => {
        setIsCampaignCompleted(true);
        gtag('event', 'campaign-complete', { campaign: id, user: userId, project: customer.id });
      })
      .catch((e) => console.log({ e }));
  };

  useEffect(() => {
    gtag('event', 'campaign-view', {
      campaign: id,
      user: userId,
      project: customer.id,
    });
  }, []);

  return (
    <div className='relative flex-[0_0_100%] w-full mr-4 p-4 gap-6 flex flex-col lg:flex-row  bg-white dark:bg-[#242424] dark:border dark:border-[#FFDA68]/30 shadow-sm rounded-3xl dark:text-white'>
      {/* <div className='lg:basis-2/3 flex flex-col sm:flex-row gap-6'> */}
      <div className='basis-2/3 flex items-start justify-center h-full overflow-hidden'>
        {/*<img src={picture.path} className='object-contain' alt={name} />*/}
        <Link to={`/campaigns/${id}`}>
          <img
            src={image?.src}
            alt={title?.en || ''}
            className='w-full h-full max-h-[600px] object-fill rounded-xl'
          />
        </Link>
      </div>
      <div className='basis-1/3 flex flex-col h-full justify-between'>
        <div>
          <header
            className='flex items-center justify-between w-max cursor-pointer'
            onClick={() => navigate(`/projects/${customer.id}`)}
          >
            <div className='flex items-center'>
              <Avatar
                name={profile?.user?.name || profile?.user?.username || ''}
                src={profile?.avatar?.src}
                className='w-11 h-11'
              />
              <h2 className='text-[26px] leading-7 font-bold ml-1.5'>
                {profile?.user?.name || profile?.user?.username || ''}
              </h2>
            </div>
          </header>
          {/*<div className='lg:hidden flex h-full basis-1/3 bg-gray-200 rounded-3xl overflow-hidden'>*/}
          {/*  <img src={picture.path} className='object-contain' alt={name} />*/}
          {/*</div>*/}
          <h3 className='text-lg leading-7 font-bold mt-7'>{title?.en}</h3>
          <div className='h-48 overflow-y-auto leading-5'>
            {description?.en?.split('\n').map((i: string, k: number) => (
              <>
                <div key={k}>{i}</div>
                <div className='w-full h-1.5' />
              </>
            ))}
          </div>
        </div>

        <div>
          <div className='w-full h-28 flex flex-col items-center justify-center mt-5 rounded-xl border border-[#E6E6E6] dark:border-[#FFDA68] text-gray-900 dark:text-[#FFDA68]'>
            <div className='text-xl font-semibold'>{t('Remaining Time')}</div>

            <div className='flex items-center space-x-2 leading-tight'>
              <div className='flex flex-col items-center'>
                <div className='text-[40px] font-semibold'>{remainingTime.days}</div>
                <div className='text-sm'>{t('Days')}</div>
              </div>

              <div className='text-[40px] font-semibold'>:</div>

              <div className='flex flex-col items-center'>
                <div className='text-[40px] font-semibold'>{remainingTime.hours}</div>
                <div className='text-sm'>{t('Hours')}</div>
              </div>

              <div className='text-[40px] font-semibold'>:</div>

              <div className='flex flex-col items-center'>
                <div className='text-[40px] font-semibold'>{remainingTime.minutes}</div>
                <div className='text-sm'>{t('Minutes')}</div>
              </div>
            </div>
          </div>

          <div className='flex items-center mt-10 space-x-3'>
            {awards.map((award: AwardsDto, k: number) => (
              <div
                key={'rewards_' + k}
                className='min-w-[120px] h-10 flex items-center px-2 bg-[#FFF597] dark:bg-transparent border border-[#FFDA68] dark:text-[#FFDA68] rounded-full'
              >
                {(award.type === 'xp' || award.type === 'USDT') && (
                  <div className='w-7 h-7 flex items-center justify-center rounded-full bg-white'>
                    <img src={award.type === 'xp' ? '/midle-m.svg' : '/usdt.svg'} />
                  </div>
                )}
                <div
                  className={classNames(
                    'flex-1 text-center text-lg font-black',
                    award.amount <= 999 ? '-ml-3.5' : 'ml-2',
                  )}
                >
                  {award.amount}
                  {award.type !== 'xp' && award.type !== 'USDT' ? ' ' + award.type : ''}
                </div>
              </div>
            ))}
          </div>

          <Link to={`/campaigns/${id}`}>
            <button className='w-full !h-14 flex items-center justify-center mt-5 px-6 bg-gray-900 dark:bg-[#FFDA68] rounded-lg text-white dark:text-[#151515] font-bold space-x-1'>
              <div>{t('Join Campaign')}</div>
              <i className='icon-fire text-xl' />
            </button>
          </Link>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
}

//     {_isCampaignCompleted ? (
//       <div className='lg:basis-1/3 flex flex-col h-full rounded-3xl min-w-[300px] items-center'>
//         <div className='flex flex-col h-full justify-center'>
//           <img src={cryptoGift} alt={t('gift')} />
//           {t('You completed this campaign!')}
//         </div>
//       </div>
//     ) : (
//       <>
//         {/*{tasks.length == completedTaskIds.length && tasks.length > 0 ? (*/}
//         {/*  <div className='lg:basis-1/3 flex flex-col h-full rounded-3xl min-w-[300px] items-center'>*/}
//         {/*    <div className='flex flex-col h-full justify-center'>*/}
//         {/*      <img src={cryptoGift} alt={t('gift')} />*/}
//         {/*      <p>{t('You completed all tasks!')}</p>*/}
//         {/*      <button*/}
//         {/*        type='button'*/}
//         {/*        onClick={handleComplete}*/}
//         {/*        className='mt-4 btn bg-blue-500 text-white'*/}
//         {/*      >*/}
//         {/*        {t('Claim your reward!')}*/}
//         {/*      </button>*/}
//         {/*    </div>*/}
//         {/*  </div>*/}
//         {/*) : (*/}
//         <div className='lg:basis-1/3 flex flex-col h-full rounded-3xl min-w-[300px]'>
//           {/*<h3 className='mb-4 flex items-center justify-between text-lg leading-7 font-bold '>*/}
//           {/*  {t('Tasks')}*/}
//           {/*  <Link to={`/projects/${customerId}`} className='text-blue-500 text-sm font-normal'>*/}
//           {/*    {t('View all')}*/}
//           {/*    <i className='icon-angle-right' />*/
